'use strict';

function getSessionVariableKey(placeId) {
  return `mpp-recommendation-${placeId}`;
}

function removeFromStorage(placeId) {
  return typeof sessionStorage !== 'undefined' && sessionStorage !== null
    ? sessionStorage.removeItem(getSessionVariableKey(placeId))
    : undefined;
}

function getFromStorage(placeId) {
  return typeof sessionStorage !== 'undefined' && sessionStorage !== null
    ? sessionStorage.getItem(getSessionVariableKey(placeId))
    : undefined;
}

function setToStorage(placeId, value) {
  if (typeof sessionStorage !== 'undefined' && sessionStorage !== null) {
    return sessionStorage.setItem(getSessionVariableKey(placeId), value);
  }
  return null;
}

class Recommendations {
  constructor({ el, csrf, placeId }) {
    this.el = el;
    this.csrf = csrf;
    this.placeId = placeId;
    this.$el = $(this.el);
    this.rootUrl = '/merchant-page';
    this.$thumbsUp = this.$el.find('.recommendations-thumbs-up');
    this.$thumbsDown = this.$el.find('.recommendations-thumbs-down');
    this.bindEventHandlers(); // automatically recommend this merchant if the user previously intended to do so and then went through the login flow

    const recommendation = getFromStorage(this.placeId);
    removeFromStorage(this.placeId);

    if (['yes', 'no'].includes(recommendation)) {
      this.recommend(recommendation, true);
    }
  }

  bindEventHandlers() {
    this.$thumbsUp.click(evt => {
      if (!this.shouldAllowClick(evt.currentTarget)) {
        return null;
      }

      return this.recommend('yes');
    });
    return this.$thumbsDown.click(evt => {
      if (!this.shouldAllowClick(evt.currentTarget)) {
        return null;
      }

      return this.recommend('no');
    });
  }

  shouldAllowClick(el) {
    // don't allow to click the thumbs up/down if the user has already clicked it
    const $el = $(el);
    return (
      !$el.hasClass('loading') &&
      !$el.hasClass('highlighted') &&
      !$('.mpp-container').hasClass('closed-merchant')
    );
  }

  showLoading(recommend) {
    if (recommend === 'yes') {
      return this.$thumbsUp.addClass('loading');
    } else {
      return this.$thumbsDown.addClass('loading');
    }
  }

  removeLoading() {
    this.$thumbsUp.removeClass('loading');
    return this.$thumbsDown.removeClass('loading');
  }

  recommend(recommend, triggeredOnPageLoad) {
    const obj = {
      recommend,
      placeId: this.placeId,
      triggeredOnPageLoad: triggeredOnPageLoad === true,
      // force boolean value
      _csrf: this.csrf,
    };
    this.showLoading(recommend);
    return $.ajax({
      url: `${this.rootUrl}/recommendations`,
      method: 'POST',
      data: JSON.stringify(obj),
      contentType: 'application/json',
      success: res => {
        this.removeLoading();

        if (MPP.JsonResponseHandler.loginRequired(res)) {
          return setToStorage(this.placeId, recommend);
        } // TODO handle other errors

        if (res.result !== 'ok') {
          return null;
        }

        if (recommend === 'yes') {
          this.$thumbsDown.removeClass('highlighted');
          this.$thumbsUp.addClass('highlighted');
        } else {
          this.$thumbsUp.removeClass('highlighted');
          this.$thumbsDown.addClass('highlighted');
        }

        if (
          this.$el.find('.recommendations-text').hasClass('no-recommendations')
        ) {
          return this.$el
            .find('.recommendations-placeholder')
            .text(I18n.t('js.modules.recommendations.thank_you'));
        } else {
          const total =
            (res.data.recommendations.recommendation != null
              ? res.data.recommendations.recommendation.positive
              : undefined) +
            (res.data.recommendations.recommendation != null
              ? res.data.recommendations.recommendation.negative
              : undefined);
          const percent =
            res.data.recommendations.recommendation != null
              ? res.data.recommendations.recommendation.percentage
              : undefined;
          this.$el.find('.recommendations-total').text(total);
          return this.$el.find('.recommendations-percent').text(`${percent}%`);
        }
      },
    });
  }
}

$(() => {
  const el = '#merchant-recommendations';

  if (!($(el).length > 0)) {
    return null;
  }

  const place = $('.mpp-container').data();
  const csrfToken = $('meta[name=csrf-token]').attr('content');
  return new Groupon.Recommendations({
    el,
    csrf: csrfToken,
    placeId: place.placeId,
  });
});
Groupon.Recommendations = Recommendations;
